import React, { useContext, useState, useEffect } from 'react';

import { useRole } from '../../../../hooks/useRole' 
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination';  
import RoleDeleteModal from '../Delete/Delete';
import RoleEditModal from '../Edit/Edit';
import AddRoleModal from '../Add/Add';
import tbl from '../../../../assets/Style/Table.module.css'
import { useTranslation } from 'react-i18next';
import cl from './RoleList.module.css'
import RoleLanguage from '../../../UI/RoleLanguage/RoleLanguage';  

const RoleList = () => {
  const {t} = useTranslation();
  const { roleService } = useRole(20, true);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
    roleService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    roleService.setFilter({
      ...roleService.filter,
      [name]: value
    });
  };

 
  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Roles')}</h1>  
        <AddRoleModal  roleService={roleService}  /> 
    </div>
   
    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
                  <th className={cl.id} >#</th>
                  <th>{t('Name')}</th>
                  <th>{t('Description')}</th>
                  <th className={ cl.btntbl }> </th>
              </tr>
          </thead>
          <tbody>
            {roleService.items.map((role) =>
                <tr key={role.id} >
                  <td className={cl.id} >{role.id} </td>
                  <td>{role.name}</td>
                  <td> 
                    <RoleLanguage role={role?.description} /> 
                  </td> 
                  <td className={ cl.btntbl }>
                    <div className={ cl.btns }>
                      <RoleEditModal roleService={roleService} defaultRole={role} />   
                      <RoleDeleteModal roleService={roleService} defaultRole={role} /> 
                    </div>
                  </td>
                </tr>  
              )}
          </tbody>
      </table>
 
      </div>



   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination 
      total={roleService.total} 
        perPage={roleService.filter.limit} 
        current={roleService.filter.page} 
        paginate={(page) => {
            roleService.setFilter({
            ...roleService.filter,
            page: page,
          });
        }}
        setLimit={(limit) => {
            roleService.setFilter({
            ...roleService.filter,
            limit: limit,
          });
        }}
    />
  </div>;
}

export default RoleList;